export default "__VITE_ASSET__142f41c9__"